import { useMemo } from 'react'

import {
  groupAttachedPages,
  type LotoAttachmentGroup,
} from './lotoAttachmentGroups'
import type { LotoAttachment, LotoReportScope } from './lotoReportSchemas'
import { useLotoPageDetails } from './useLotoPageDetails'

type UseLotoAttachedPagesResult = {
  groups: LotoAttachmentGroup[]
  isLoading: boolean
  error: Error | undefined
}

export function useLotoAttachedPages(
  scope: LotoReportScope,
  attachments: LotoAttachment[]
): UseLotoAttachedPagesResult {
  const { details, isLoading, error } = useLotoPageDetails(scope, attachments)
  const groups = useMemo(
    () => groupAttachedPages(attachments, details),
    [attachments, details]
  )
  return { groups, isLoading, error }
}
